import { createContext, useContext } from 'react';

// Context for managing 403 forbidden state
export type ForbiddenContextType = {
  isForbidden: boolean;
  setIsForbidden: (value: boolean) => void;
  forbiddenPath?: string | null;
  setForbiddenPath?: (path: string | null) => void;
};

export const ForbiddenContext = createContext<ForbiddenContextType | undefined>(undefined);

export const useForbiddenState = () => {
  const context = useContext(ForbiddenContext);
  if (!context) {
    throw new Error('useForbiddenState must be used within ApiProvider');
  }
  return context;
};
